// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"f856696e","293":"03047730","298":"5f7c774d","372":"ebd581b1","472":"0ed93c78","615":"b93a1b32","650":"6be5b77a","735":"77c87290","750":"3d9559da","937":"1ec0fca2"}[chunkId] + ".chunk.js";
};